<template>
  <div class="columns">
    <div class="column">
      <div class="content">
        <h2 class="title">EVTC Inspector</h2>
        <p>
          A program for exploring EVTC files. Mostly useful for developers.
        </p>
        <p>
          Accessible from the <router-link :to="{path: '/tools/manager'}">Log Manager</router-link>.
          Enable the View -> Debug Data option, select a log and click the Debug Data button.
        </p>
        <h3>Features</h3>
        <ul>
          <li>See raw combat item data</li>
          <li>See raw agent data</li>
          <li>
            See combat items processed into "events" with properly resolved agents, skills and
            similar.
          </li>
          <li>
            Browse through agents and events they are involved in
          </li>
        </ul>
      </div>
    </div>
    <div class="column is-4">
      <ProgramDownloads release-feed-url="/releases/inspector.json" program-name="EVTC Inspector"/>
      <ProgramImage :src="evtcInspectorImage" alt="EVTC Inspector"/>
    </div>
  </div>
</template>

<script>
import ProgramDownloads from "@/components/ProgramDownloads";
import ProgramImage from "@/components/ProgramImage";
import evtcInspectorImage from "@/assets/images/evtc-inspector.png";

export default {
  name: 'tools-inspector',
  components: {ProgramDownloads, ProgramImage},
  data() {
    return {
      evtcInspectorImage
    }
  }
}
</script>

<style>
</style>
